import { Form, FormItem } from '@magicdoorinc/form';
import { Button, LabeledSelect, useLocalization } from '@magicdoorinc/ui';
import { onMount } from 'solid-js';
import { CompanyTypeConfirmStep, useBankAccountsList, useCompanyTypeConfirm } from '~/contexts/local';
import { getBankAccountOptions as getAvailableBankAccountOptions } from '~/utils/bankAccountLinkStatus';
import type { Component } from 'solid-js';

const SelectDefaultCompanyBankAccountContent: Component = () => {
  const { t } = useLocalization();
  const { resolveSelfManagedStore, selectDefaultBankAccountForm } = useCompanyTypeConfirm();
  const { bankAccounts } = useBankAccountsList();

  onMount(() => {
    const { defaultCompanyBankAccountId } = resolveSelfManagedStore;
    selectDefaultBankAccountForm.setFormStore({
      defaultCompanyBankAccountId: defaultCompanyBankAccountId,
    });
  });

  const availableBankAccountOptions = () => {
    const companyBankAccountIds = resolveSelfManagedStore.companyBankAccountIds;
    if (!companyBankAccountIds) return [];
    return getAvailableBankAccountOptions(bankAccounts() ?? []).filter((bankAccount) => companyBankAccountIds.includes(bankAccount.value));
  };

  return (
    <div class="p-5">
      <Form defaultForm={selectDefaultBankAccountForm} class="flex flex-col gap-5">
        <FormItem
          component={LabeledSelect}
          label={t('Choose a bank as your default company operating account')}
          labelClass="normal-case"
          options={availableBankAccountOptions()}
          placeholder={t('Select bank account')}
          class="w-full"
          formFieldName="defaultCompanyBankAccountId"
          rules={[{ required: true, message: t('Please select a default company operating account') }]}
        />
      </Form>
    </div>
  );
};

export const SelectDefaultCompanyBankAccountFooter: Component = () => {
  const { t } = useLocalization();
  const { setStep, handleSelectDefaultNext } = useCompanyTypeConfirm();

  const handleCancel = () => {
    setStep(CompanyTypeConfirmStep.SelectCompanyBankAccounts);
  };

  return (
    <div class="flex items-center justify-between border-t border-separator bg-white px-5 py-4">
      <Button variant="outlined" onClick={handleCancel}>
        {t('Back')}
      </Button>
      <Button onClick={handleSelectDefaultNext}>{t('Next')}</Button>
    </div>
  );
};

export default SelectDefaultCompanyBankAccountContent;
